
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offerings_overview",
      function () {
        return require("private-next-pages/offerings_overview.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offerings_overview"])
      });
    }
  